<template>
  <div class="pa-2 rounded-lg" style="background-color: white;">
    <h3>{{ title }}</h3>
    
    <div class="d-flex flex-row mt-2" style="overflow-x: auto">
      <div class="d-flex flex-column align-center mr-2"
        v-for="service in services"
        :key="`f-${service.service_id}`" 
        @click="$emit('click', service)"
        style="max-width: 80px;"
      >
        <v-img class="rounded elevation-3" v-if="service.service_image_url" max-width="80px" max-height="45px" :src="service.service_image_url" />
        <div v-else class="rounded grey" style="width: 80px; height: 45px"></div>
        <div style="font-size: 10px;">{{ service.service }}</div>
      </div>
    </div>
  </div>
</template>


<script>

  export default {
    name: 'FrequentServices',

    props: ['services', 'title'],
  }
</script>